import { render, staticRenderFns } from "./BorderBox9.vue?vue&type=template&id=bfc2778a"
import script from "./BorderBox9.vue?vue&type=script&lang=js"
export * from "./BorderBox9.vue?vue&type=script&lang=js"
import style0 from "./BorderBox9.vue?vue&type=style&index=0&id=bfc2778a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports